/**
 * Check auth hook
 */

import { useEffect, useState } from 'react'
import type { User } from '@/types/user'
/**
 * Custom hook to check if the user is authenticated
 */

export type AuthResponse = {
    authenticated: boolean
    message: string
    success?: boolean
}

export const useAuth = () => {
	const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		const checkAuth = async () => {
			try {
				// Check if the user is authenticated
				const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/session`, {
					credentials: 'include',
				})
				const data: AuthResponse = await response.json()
				setIsAuthenticated(data.authenticated ?? false)
                setIsLoading(false)
			} catch (error) {
                setIsAuthenticated(false)
                setIsLoading(false)
			}
		}
		checkAuth()
	}, [])

	return {isAuthenticated, isLoading}
}

export const fetchUser = async () => {
	try {
		const url = `${process.env.REACT_APP_API_URL}/auth/me`
		const response = await fetch(url, {
			credentials: 'include',
		})
		const data = await response.json()

		if(data.success) {
			return data.user as User
		} else {
			throw new Error(data.message)
		}
	} catch (error) {
		console.log('Error fetching user', error)
		throw new Error('Error fetching user')
	}
}